import React, { useState, useEffect, useContext } from "react";
import Header from "../../elements/Header";
import { EnvContext } from "../../context/EnvContext";
import Footer from "../../elements/Footer";
import config from "../../config";
import { getAuth } from "firebase/auth";
import { useFirestore } from "../../firebase/FirestoreContext";
import { doc, getDoc } from "firebase/firestore";
import FAQ from "../../elements/FAQ";

const PrivacyPolicy = ({ }) => {
  //
  const firestore = useFirestore();
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  // Get FDA disclaimer data from the server /_DEVELOPMENT/stageapi/Help/Legal/Legal/LegalFDA legalContent and show as HTML content
  const [legalContent, setLegalContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLegalContent = async () => {
      try {
        const docRef = doc(firestore, `${collectionPath}Help/Legal/Legal`, "LegalPrivacy"); // Path to the document
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setLegalContent(data.legalContent); // Assuming the field in Firestore is named 'legalContent'
          setLoading(false);
        } else {
          console.log("No such document!");
          setError("No FDA Disclaimer found.");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching legal content:", error);
        setError(error.message); // Set error state to the error message
        setLoading(false);
      }
    };

    fetchLegalContent();
  }, []);

  useEffect(() => {
    console.log("legalContent:", legalContent); // Check if legalContent has data
  }, [legalContent]);

  //
  return (
    <div>
      <Header />
      <div style={{ padding: "20px", maxWidth: "1140px", margin: "0 auto" }}>
        {legalContent && (
          <div
            style={{}}
            dangerouslySetInnerHTML={{ __html: legalContent }} // Render HTML content
          />
        )}
        <FAQ />
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
